import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CurationEditorHelper } from '../../../curation-editor-helper';
import { ICurationItem } from '../../../../../interfaces/curation-item.interface';

@Component({
  selector: 'gen-curation-editor-clinical-significances-container',
  templateUrl: './curation-editor-clinical-significances-container.component.html',
  styleUrls: ['curation-editor-clinical-significances-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CurationEditorClinicalSignificancesContainerComponent implements OnInit {
  @Output() validated: EventEmitter<any> = new EventEmitter();
  @Output() itemDeleted: EventEmitter<any> = new EventEmitter();
  @Input() readOnly: boolean;
  @Input() diagnosticFormName: string;
  @Input() prognosticFormName: string;
  @Input() therapeuticFormName: string;
  @Input() hideCheckBox: boolean = false;
  @Input() revisionTag: string;
  @Input() submitted: boolean = false;
  @Input() approvedMode: boolean = false;
  @Input() curationItem: ICurationItem;
  @Input() searchDataConfigParams: any;
  @Input() googleSearchURL: string;
  @Input() pubmedSearchURL: string;

  public title: string = 'Clinical Significances';
  public rootType: string = CurationEditorHelper.CLINICAL_SIG_ROOT;
  public _curationData: any = { };
  public noClinicalSignificancePublications: boolean = false;
  public clinicalSignificanceDataExists: boolean = false;

  @Input() set curationData(data) {
    if (data) {
      this._curationData = data;
      this.calculateState();
    }
  }

  get noClinicalSignificancePublicationsShowChanged(): boolean {
    const bool: boolean = !this.approvedMode &&
      this._curationData['noClinicalSignificancePublicationsChangedRevisionId'] != undefined &&
      this._curationData['noClinicalSignificancePublicationsChangedRevisionId'] == this.revisionTag;

    return bool;
  }

  constructor() { }

  ngOnInit() { }

  private calculateState() {
    if (this._curationData['clinicalSignificances']) {
      // Checkbox is enabled only when no clinical sig data was exists (deleted items should not be counted)
      const notDeletedItems = this._curationData['clinicalSignificances'].filter(item => typeof(item['deleted']) === 'undefined' || item['deleted'] == false);
      this.clinicalSignificanceDataExists = notDeletedItems && notDeletedItems.length > 0;
    }
    if (this._curationData['noClinicalSignificancePublications']) {
      this.noClinicalSignificancePublications = this._curationData['noClinicalSignificancePublications'];
    }
  }

  noPublicationChecked(checked) {
    this._curationData['noClinicalSignificancePublications'] = checked;
    this._curationData['noClinicalSignificancePublicationsChangedRevisionId'] = this.revisionTag;
  }

  deleteItem(deletedItem) {
    this.calculateState();
    this.itemDeleted.emit(deletedItem);
  }

  itemAdded(addedItem) {
    this.calculateState();
  }

  validationEvent($event) {
    this.validated.emit($event);
  }
}
